import { FriendlyKeyValueUrl, KeyValue, MetaSegment } from "@skv/core";
import * as React from "react";

export interface GlobalStaticProps {
  categoryList: FriendlyKeyValueUrl[];
  commitmentList: KeyValue[];
  dayAndTimeList: KeyValue[];
  genders: KeyValue[];
  majorCities: MetaSegment[];
  suitableForList: KeyValue[];
  typeOfWorkList: KeyValue[];

  staticRoutes?: string[]; // au + nz, todo figure out how to remove for nsw?
  adviceAndTipsCategoryRoutes?: (KeyValue & { slug: string })[];
}

const GlobalStaticContext = React.createContext<GlobalStaticProps | undefined>(
  undefined
);

interface GlobalStaticProviderProps {
  value: GlobalStaticProps;
}

export const GlobalStaticProvider: React.FC<GlobalStaticProviderProps> = ({
  children,
  value,
}) => {
  return (
    <GlobalStaticContext.Provider value={value}>
      {children}
    </GlobalStaticContext.Provider>
  );
};

export const useGlobal = (): GlobalStaticProps => {
  const ctx = React.useContext(GlobalStaticContext);

  if (!ctx) {
    throw Error(
      "useGlobal hook called outside a <GlobalStaticProvider /> component"
    );
  }

  return ctx;
};
